import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Message = _resolveComponent("Message")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "metaweb-attribute-unused-field-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.metawebAttributeUnusedFieldDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.addUnusedFields')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (_ctx.fields.length === 0)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "p-m-4",
            severity: "info",
            closable: false,
            style: _ctx.metawebAttributeUnusedFieldDialogDescriptor.styles.message
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.noUnusedFields')), 1)
            ]),
            _: 1
          }, 8, ["style"]))
        : (_openBlock(), _createBlock(_component_Listbox, {
            key: 2,
            class: "metaweb-unused-fields-listbox p-m-4",
            options: _ctx.fields
          }, {
            option: _withCtx((slotProps) => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_Checkbox, {
                  class: "p-mr-2",
                  modelValue: _ctx.selectedUnusedFields,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedUnusedFields = $event)),
                  value: slotProps.option
                }, null, 8, ["modelValue", "value"]),
                _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["options"]))
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}